/* eslint-disable consistent-return */
import React, { useState } from 'react';
import * as dates from '@simplybenefits/sb-dates';
import Grid from "@mui/material/Grid";
import { Chip } from "@mui/material";
import Text from '../../components/Text.js';
import { colors, fonts } from '../../theme/index.js';
import TextInput from '../../components/TextFields/TextInput.js';
import DateInput from '../../components/TextFields/DateInput.js';
import Button from '../../components/Button.js';
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormHelperText from "@mui/material/FormHelperText";
import * as Services from '../../services/index.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
const styles = {
  benefitBlock: {
    backgroundColor: colors.surface,
    display: 'block',
    padding: 15,
    position: 'relative',
    border: `1px solid #eee`,
    borderRadius: 3,
    marginBottom: 10,
    marginTop: 10
  },
  signageAcceptBox: {
    paddingTop: '10px',
    marginTop: '-15px'
  },
  signature: {
    fontFamily: 'this.props.product.dependentCoverageSetting',
    fontWeight: 'bold'
  }
};

/**
 * @param changes
 * @returns {JSX.Element}
 */
const formatChanges = changes => {
  const lines = changes.split('\n');
  return /*#__PURE__*/React.createElement("div", null, lines.map(line => {
    line = line.trim();
    if (line.length === 0) {
      return null;
    }
    if (line.charAt(0) === '-') {
      line = line.slice(1);
    }
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      },
      key: line
    }, /*#__PURE__*/React.createElement(Text, {
      color: colors.darkGrey,
      medium: true,
      display: "block",
      customStyle: {
        paddingLeft: 5
      }
    }, "\u2022"), /*#__PURE__*/React.createElement(Text, {
      color: colors.darkGrey,
      medium: true,
      display: "block",
      customStyle: {
        paddingLeft: 5
      }
    }, line));
  }));
};

/**
 * @param classes
 * @param whitelabel
 * @param title
 * @param benefitData
 * @returns {JSX.Element}
 */
const benefitBlock = (whitelabel, title, benefitData) => {
  if (benefitData?.changes?.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    style: styles.benefitBlock
  }, /*#__PURE__*/React.createElement(Text, {
    color: whitelabel.primaryColor || colors.skyBlue,
    mediumLarge: true,
    bold: true
  }, title), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 20
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true,
    bold: true,
    display: "block",
    margin: "0 0 5px 0"
  }, i18n.t(tokens.labels.amendments.requestedChanges)), /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true,
    display: "block"
  }, formatChanges(benefitData.changes))), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 20
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true,
    bold: true
  }, i18n.t(tokens.labels.amendments.soloRateCurrent)), /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true,
    margin: "5px 0 0 0"
  }, "$", benefitData.rates.current.solo)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true,
    bold: true
  }, i18n.t(tokens.labels.amendments.duoRateCurrent)), /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true,
    margin: "5px 0 0 0"
  }, "$", benefitData.rates.current.duo)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true,
    bold: true
  }, i18n.t(tokens.labels.amendments.familyRateCurrent)), /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true,
    margin: "5px 0 0 0"
  }, "$", benefitData.rates.current.family))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true,
    bold: true
  }, i18n.t(tokens.labels.amendments.soloRateNew)), /*#__PURE__*/React.createElement(Text, {
    color: whitelabel.primaryColor || colors.skyBlue,
    medium: true,
    bold: true,
    margin: "5px 0 0 0"
  }, "$", benefitData.rates.new.solo)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true,
    bold: true
  }, i18n.t(tokens.labels.amendments.duoRateNew)), /*#__PURE__*/React.createElement(Text, {
    color: whitelabel.primaryColor || colors.skyBlue,
    medium: true,
    bold: true,
    margin: "5px 0 0 0"
  }, "$", benefitData.rates.new.duo)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true,
    bold: true
  }, i18n.t(tokens.labels.amendments.familyRateNew)), /*#__PURE__*/React.createElement(Text, {
    color: whitelabel.primaryColor || colors.skyBlue,
    medium: true,
    bold: true,
    margin: "5px 0 0 0"
  }, "$", benefitData.rates.new.family)))));
};

/**
 * @param classes
 * @param classData
 * @param whitelabel
 * @param amendment
 * @param isAuthorityView
 * @param completeApproval
 * @returns {JSX.Element}
 * @constructor
 */
const AmendmentDisplay = ({
  classData,
  whitelabel,
  amendment,
  isAuthorityView,
  completeApproval
}) => {
  const [authoritySignature, setAuthoritySignature] = useState(amendment.signage.signature || "");
  const [authorityName, setAuthorityName] = useState(amendment.signage.name || "");
  const [authorityAcceptedTerms, setAuthorityAcceptedTerms] = useState(amendment.signage.acceptedTerms || false);
  const [authorityTimestampOfAcceptance, setAuthorityTimestampOfAcceptance] = useState(amendment.signage.timestampOfAcceptance || null);
  const [authorityDatedOn, setAuthorityDatedOn] = useState(amendment.signage.datedOn ? Services.dates.formatIncomingDate(amendment.signage.datedOn) : null);
  const [errors, setErrors] = useState({});

  /**
   * Validate the signage block and call the completeApproval
   * @returns {Promise<null>}
   * @private
   */
  const _completeApproval = async () => {
    let authoritySignatureError = await Services.validateInput('checkEmpty', authoritySignature);
    const authorityNameError = await Services.validateInput('checkEmpty', authorityName);
    const authorityAcceptedTermsError = !authorityAcceptedTerms ? i18n.t(tokens.labels.banking.youMustAcceptTermsError) : false;
    const authorityDatedOnError = await Services.validateInput('date', authorityDatedOn);
    if (authoritySignature !== authorityName) {
      authoritySignatureError = i18n.t(tokens.labels.signage.signageNameError);
    }
    setErrors({
      authoritySignatureError,
      authorityNameError,
      authorityAcceptedTermsError,
      authorityDatedOnError
    });
    if (authoritySignatureError || authorityNameError || authorityAcceptedTermsError || authorityDatedOnError) {
      return null;
    }
    completeApproval({
      name: authorityName,
      signature: authoritySignature,
      acceptedTerms: authorityAcceptedTerms,
      timestampOfAcceptance: authorityTimestampOfAcceptance,
      datedOn: dates.getUTC(authorityDatedOn)
    });
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };
  const amendmentStatus = amendment.status.toUpperCase();
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 30
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    mediumLarge: true,
    bold: true,
    margin: "0 0 5px 0"
  }, i18n.t(tokens.labels.admin.effectiveDate)), /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true
  }, dates.getUTC(amendment.effectiveDate, 'll', i18n.locale)), amendment.requestedAccountDetailChanges.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    mediumLarge: true,
    bold: true,
    margin: "30px 0 5px 0"
  }, i18n.t(tokens.labels.amendments.accountDetailChanges)), /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true
  }, formatChanges(amendment.requestedAccountDetailChanges))), amendment.requestedClassChanges.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    mediumLarge: true,
    bold: true,
    margin: "30px 0 5px 0"
  }, i18n.t(tokens.labels.amendments.classChanges)), /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true
  }, formatChanges(amendment.requestedClassChanges))), amendment.requestedDivisionChanges && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    mediumLarge: true,
    bold: true,
    margin: "30px 0 5px 0"
  }, i18n.t(tokens.labels.amendments.divisionChanges)), /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true
  }, formatChanges(amendment.requestedDivisionChanges))), amendment.requestedAdminFeeChanges && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    mediumLarge: true,
    bold: true,
    margin: "30px 0 5px 0"
  }, i18n.t(tokens.labels.amendments.adminFeeChanges)), /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true
  }, formatChanges(amendment.requestedAdminFeeChanges))), amendment.requestedBenefitChanges.selectedClasses.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    mediumLarge: true,
    bold: true,
    margin: "30px 0 5px 0"
  }, i18n.t(tokens.labels.amendments.benefitChanges)), /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    medium: true
  }, i18n.t(tokens.labels.amendments.followingClassesWillBeAmended)), amendment.requestedBenefitChanges.selectedClasses.map(selectedClassID => /*#__PURE__*/React.createElement(Chip, {
    key: selectedClassID,
    size: "medium",
    label: classData[selectedClassID].title,
    color: "default",
    clickable: false,
    variant: "default",
    style: {
      cursor: "default",
      padding: 15,
      margin: "10px 10px 10px 0",
      borderRadius: 20,
      borderWidth: 2,
      fontFamily: fonts.type.heading,
      fontSize: 12,
      color: '#000',
      minWidth: 100,
      backgroundColor: '#eee'
    }
  })), benefitBlock(whitelabel, i18n.t(tokens.titles.lifeInsurance), amendment.requestedBenefitChanges.lifeInsurance), benefitBlock(whitelabel, i18n.t(tokens.titles["ad&d"]), amendment.requestedBenefitChanges.add), benefitBlock(whitelabel, i18n.t(tokens.titles.dependentLife), amendment.requestedBenefitChanges.dependentLife), benefitBlock(whitelabel, i18n.t(tokens.titles.shortTermDisability), amendment.requestedBenefitChanges.std), benefitBlock(whitelabel, i18n.t(tokens.titles.longTermDisability), amendment.requestedBenefitChanges.ltd), benefitBlock(whitelabel, i18n.t(tokens.titles.criticalIllness), amendment.requestedBenefitChanges.criticalIllness), benefitBlock(whitelabel, i18n.t(tokens.titles.drugs), amendment.requestedBenefitChanges.drugs), benefitBlock(whitelabel, i18n.t(tokens.titles.healthcare), amendment.requestedBenefitChanges.healthcare), benefitBlock(whitelabel, i18n.t(tokens.titles.dental), amendment.requestedBenefitChanges.dental), benefitBlock(whitelabel, i18n.t(tokens.titles.spendingAccounts), amendment.requestedBenefitChanges.spendingAccounts), benefitBlock(whitelabel, i18n.t(tokens.titles.efap), amendment.requestedBenefitChanges.efap), benefitBlock(whitelabel, i18n.t(tokens.titles.virtualHealthCare), amendment.requestedBenefitChanges.virtualHealthcare), benefitBlock(whitelabel, i18n.t(tokens.titles.financialAwareness), amendment.requestedBenefitChanges.financialAwareness)), /*#__PURE__*/React.createElement(Text, {
    color: colors.darkGrey,
    mediumLarge: true,
    bold: true,
    margin: "30px 0 0 0"
  }, i18n.t(tokens.labels.amendments.signingAuthoritySignature)), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.masterApplication.authoritySignature),
    fullWidth: true,
    variant: "outlined",
    value: authoritySignature,
    onChange: e => setAuthoritySignature(e.target.value),
    inputProps: {
      inputProps: {
        style: {
          ...styles.signature
        }
      }
    },
    disabled: !isAuthorityView || amendmentStatus === 'APPROVED',
    error: errors.authoritySignatureError
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.masterApplication.authorityName),
    fullWidth: true,
    variant: "outlined",
    value: authorityName,
    onChange: e => setAuthorityName(e.target.value),
    disabled: !isAuthorityView || amendmentStatus === 'APPROVED',
    error: errors.authorityNameError
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(DateInput, {
    label: i18n.t(tokens.labels.masterApplication.authorityDatedOn),
    fullWidth: true,
    variant: "outlined",
    value: authorityDatedOn,
    onChange: e => setAuthorityDatedOn(e.target.value),
    disabled: !isAuthorityView || amendmentStatus === 'APPROVED',
    error: errors.authorityDatedOnError
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: styles.signageAcceptBox
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(FormGroup, {
    row: true
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: Boolean(authorityAcceptedTerms),
      onChange: () => {
        setAuthorityAcceptedTerms(!authorityAcceptedTerms);
        setAuthorityTimestampOfAcceptance(dates.getUTC());
      },
      value: "authorityAcceptedTerms",
      disabled: !isAuthorityView || amendmentStatus === 'APPROVED'
    }),
    label: i18n.t(tokens.labels.amendments.amendmentAcknowledgement)
  })), errors.authorityAcceptedTermsError && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, i18n.t(tokens.labels.banking.youMustAcceptTermsError))))), isAuthorityView && amendmentStatus === 'UNDER REVIEW' && /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    customStyle: {
      display: 'block',
      height: 50,
      textTransform: "capitalize",
      fontSize: 16,
      margin: "40px 0 0 0",
      marginLeft: 'auto'
    },
    onClick: _completeApproval
  }, i18n.t(tokens.buttons.approveAmendment)));
};
export default AmendmentDisplay;